import { render, staticRenderFns } from "./Create-old.vue?vue&type=template&id=98683c2e&scoped=true&"
import script from "./Create-old.vue?vue&type=script&lang=js&"
export * from "./Create-old.vue?vue&type=script&lang=js&"
import style0 from "./Create-old.vue?vue&type=style&index=0&id=98683c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98683c2e",
  null
  
)

export default component.exports